export const FETCH_SPECIFIC_USER_DETAIL_REQUEST = 'FETCH_SPECIFIC_USER_DETAIL_REQUEST'
export const FETCH_SPECIFIC_USER_DETAIL_SUCCESS = 'FETCH_SPECIFIC_USER_DETAIL_SUCCESS'
export const FETCH_SPECIFIC_USER_DETAIL_FALIURE = 'FETCH_SPECIFIC_USER_DETAIL_FALIURE'
